import { GetExperiment } from '@carvana/core-experiment';
import { datadogRum } from '@datadog/browser-rum';

export const EXPERIMENT_BUCKET_TIMEOUT_MS = 12_000;

export const NO_BUCKET = '';

type BucketExperimentArgs = Parameters<typeof GetExperiment>[0];

export async function bucketExperiment(args: BucketExperimentArgs, context: string): Promise<string> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    const assignedBucket = await Promise.race([
      GetExperiment(args),
      new Promise<never>((_, reject) => {
        timer = setTimeout(
          () => reject(new Error(`experiment bucketing timed out after ${EXPERIMENT_BUCKET_TIMEOUT_MS}ms`)),
          EXPERIMENT_BUCKET_TIMEOUT_MS
        );
      }),
    ]);
    return assignedBucket ?? NO_BUCKET;
  } catch (error) {
    try {
      datadogRum.addError(error, { context, experiment: args?.name });
    } catch {
      /* empty */
    }
    return NO_BUCKET;
  } finally {
    if (timer) clearTimeout(timer);
  }
}
